// extracted by mini-css-extract-plugin
export default {"icons":"styles_icons__QJ3wJ","singleIcon":"styles_singleIcon__8SwTt"};